export const INSIGHTS_HABITS_SPLIT = 'insights-habits'
